<template>
  <header id="header">
    <div class="container">
      <router-link to="/" id="logo">
        <icon-base width="180" height="46" viewBox="0 0 180 46"><icon-logo-2/></icon-base>
      </router-link>

      <div class="authorization-box" :class="isAdmin ? 'admin' : ''">
        <div class="authorization-wrap">
          <span class="name">{{isAdmin ? username : company}} /</span>
          <a href="#" @click.prevent="logoutUser" to="/logout" class="link">Logout</a>
        </div>
        <span class="number-wrap" v-if="!isAdmin"><span class="num-title">Account number:</span> <span class="num">#{{accountNumber}}</span></span>
      </div>
    </div>
  </header>
</template>

<script>
import IconBase from "./common/IconBase";
import IconLogo2 from "./common/icons/IconLogo2";
import { mapGetters, mapState, mapActions } from "vuex"


export default {
    name: 'app-header',
    props: {
      isAdmin: {
          type: Boolean,
          default: false
      }
    },
    components: {IconLogo2, IconBase},
    computed: {
        ...mapState('user', [
            'username',
            'company',
            'accountNumber',
            'roles'
        ]),
        ...mapGetters('user', [
            'isAuthenticated',
        ]),
    },
    methods: {
        ...mapActions('user', [
            'logoutUser'
        ])
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
